import { ChatChannelType, type IChatConversation } from 'src/@types/chat';

export const isChatChannelHidden = (
  chatChannel: IChatConversation,
  userId: string,
) => {
  if (chatChannel.type === ChatChannelType.TEXT && chatChannel.p2p) {
    return chatChannel.hidden === true;
  }

  return (
    typeof chatChannel.hidden === 'object' &&
    chatChannel.hidden?.[userId] === true
  );
};
